import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetInventoryInventoryVolumesMutation } from '../apis';
import type { InventoryVolumeQueryLinkerSchema } from '../schemas';

export function InventoryInventoryVolumesSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<InventoryVolumeQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: InventoryVolumeQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/inventory-volumes/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => `${item.id}`}
      useApi={useGetInventoryInventoryVolumesMutation}
      disabled={disabled}
    />
  );
}
